import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ForkliftDto } from '@shared/src/dtos/accesscontrol/forklift/ForkliftDto';
import { AccessControlGatePlateDto } from '@shared/src/dtos/accesscontrol/gate/plate/AccessControlGatePlateDto';
import { HColor } from '@shared/src/datatypes/HColor';

@Component({
    selector: 'shared-forklift-left-route',
    templateUrl: './shared.forklift.left.route.component.html',
    styleUrls: ['./shared.forklift.left.route.component.scss']
})
export class SharedForkliftLeftRouteComponent {

    @Output() public clickRoute = new EventEmitter<AccessControlGatePlateDto>();

    public backgroundColor: string = "#ffffff";

    private _value: AccessControlGatePlateDto | null = null;
    @Input() public set value(v: AccessControlGatePlateDto) {
        this._value = v;
        this.backgroundColor = HColor.getColor(v?.backgroundColor, 'ffffff');
    }
    public get value(): AccessControlGatePlateDto | null {
        return this._value;
    }

    public pretty(value: any): string {
        return JSON.stringify(value);
    }
}
